import styled from 'styled-components';
export const Container = styled.div `
  padding: 24px 0;
`;
export const SectionLabel = styled.h3 `
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 16px 0;
  color: var(--color-text-primary);
`;
export const StatusInfo = styled.div `
  font-size: 14px;
  color: var(--color-text-secondary);
  margin-bottom: 24px;
`;
export const ButtonContainer = styled.div `
  display: flex;
  gap: 12px;
  align-items: center;
`;
export const InfoText = styled.div `
  font-size: 14px;
  color: var(--color-text-secondary);
  line-height: 1.5;
  padding: 12px;
  background-color: var(--color-background-secondary);
  border-radius: 6px;
  border-left: 3px solid var(--color-border-primary);
`;
